var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"overlay","appear":""}},[_c('div',{class:['dark-overlay', 'overlay-variant-' + _vm.overlayState.type],on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.handleOverlayClick.apply(null, arguments)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }